import { connect } from 'react-redux';
import { uploadCueSheetFile } from 'redux-core/import-cuesheet/actions';

const mapDispatchToProps = {
  uploadCueSheetFile,
};

export default connect(null, mapDispatchToProps);
